/**
 * UI-only check: /profile/me returns RoleInfo with enum name in `roleName`, not `roleType`.
 * Login payload (AuthModel) also exposes `role.roleName`. Normalize and match conservatively.
 */

const NORMALIZED_SUPERADMIN_TOKENS = new Set(['SUPERADMIN', 'ROLESUPERADMIN'])

export function normalizeRoleTokenForSuperAdminCheck(raw: string | null | undefined): string {
  if (raw == null) return ''
  return String(raw).trim().toUpperCase().replace(/[\s\-_]/g, '')
}

function pushToken(out: string[], value: unknown) {
  if (value == null || value === '') return
  const n = normalizeRoleTokenForSuperAdminCheck(String(value))
  if (n) out.push(n)
}

function appendRoleLikeTokens(roleObj: unknown, out: string[]) {
  if (!roleObj || typeof roleObj !== 'object') return
  const r = roleObj as Record<string, unknown>
  pushToken(out, r.roleType)
  pushToken(out, r.name)
  pushToken(out, r.roleName)
  pushToken(out, r.code)
}

function collectTokensFromRecord(u: Record<string, unknown>): string[] {
  const out: string[] = []
  pushToken(out, u.roleType)
  pushToken(out, u.accountType)
  appendRoleLikeTokens(u.role, out)

  const userDetails = u.userDetails
  if (userDetails && typeof userDetails === 'object') {
    const d = userDetails as Record<string, unknown>
    pushToken(out, d.roleType)
    appendRoleLikeTokens(d.role, out)
  }

  return out
}

/**
 * Returns true if any normalized role/account token matches platform super-admin aliases.
 * Accepts UserModel, AuthModel, or any partial object with nested `role`.
 */
export function isPlatformSuperAdmin(
  authUser: unknown,
  ...more: unknown[]
): boolean {
  const buckets: unknown[] = [authUser, ...more]
  for (const obj of buckets) {
    if (!obj || typeof obj !== 'object') continue
    const tokens = collectTokensFromRecord(obj as Record<string, unknown>)
    if (tokens.some((t) => NORMALIZED_SUPERADMIN_TOKENS.has(t))) return true
  }
  return false
}
